import React from 'react';
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";
import DropdownCountries from "root/ReactHookForm/ui/DropdownCountries";

import { FormInput, FormInputCheckbox } from "../../../ReactHookForm/FormComponents";
import DropdownStaticEthnicity from "root/ReactHookForm/ui/DropdownStaticEthnicity";
import {useSessionContext} from "root/Contexts/SessionContext";

const HookSubFormEAL = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const { loggedOnUserIsTeacher } = useSessionContext() ;

    const isUASC = watch(sectionName + '.asylum_status')
    const isEAL = watch(sectionName + '.eal_flag')

    const validateCountry = (val) =>
    {
        if (val === null)
        {
            return "Please Select a country.";
        }
    }

    const validateEthnicity = (val) =>
    {
        if (val === null)
        {
            return "Please Select an ethnicity value.";
        }
    }

    return (
        <FieldsetContainer title='EAL'>

            { loggedOnUserIsTeacher === false && <BootstrapRow key='eth'>
                <BootstrapCol width={6}>
                    <label className='col-form-label'>Ethnicity</label>
                    <DropdownStaticEthnicity name={sectionName + '.ethnicity'} control={control} register={register} rules={{validate: validateEthnicity}}
                                             placeHolder='Select an ethnicity value' readOnly={readOnly}/>
                    {formErrors[sectionName]?.ethnicity?.type === 'validate' && <ErrorDiv>Please select a value</ErrorDiv>}
                </BootstrapCol>
                <BootstrapCol width={6}>
                </BootstrapCol>
            </BootstrapRow> }

            <BootstrapRow>
                <BootstrapCol width={4}>
                    <FormInputCheckbox readOnly={readOnly} label='UASC' sectionName={sectionName} name={'asylum_status'} register={register}/>
                </BootstrapCol>

                {isUASC === true && <BootstrapCol width={8}>
                    <label className='col-form-label'>Country Of Origin</label>
                    <DropdownCountries name={sectionName + '.country_id'} control={control} rules={{validate: validateCountry}}
                                       placeHolder='Country' readOnly={readOnly}/>
                    {formErrors[sectionName]?.country_id?.type === 'validate' && <ErrorDiv>Please select a country</ErrorDiv>}
                </BootstrapCol>}
                {isUASC === false && <BootstrapCol width={8}> </BootstrapCol>}
            </BootstrapRow>

            <BootstrapRow>

                <BootstrapCol width={4}>
                    <FormInputCheckbox readOnly={readOnly} label='English as an additional Language?' sectionName={sectionName} name={'eal_flag'} register={register}/>
                </BootstrapCol>

                { isEAL === true &&
                <BootstrapCol width={4}>
                    <FormInput readOnly={readOnly} label='First Language' sectionName={sectionName} name={'first_language'} register={register} required={true} maxLength={100} formErrors={formErrors}/>
                </BootstrapCol> }
                { isEAL === false && <BootstrapCol width={4}></BootstrapCol> }

                { isEAL === true &&
                <BootstrapCol width={4}>
                    <FormInput readOnly={readOnly} label='Preferred Language' sectionName={sectionName} name={'preferred_language'} register={register} required={true} maxLength={100} formErrors={formErrors}/>
                </BootstrapCol> }
                { isEAL === false && <BootstrapCol width={4}></BootstrapCol> }
            </BootstrapRow>
        </FieldsetContainer>
    )
}


export default HookSubFormEAL;
